// COB2B-803: recently viewed products. Product pages push their handle into
// localStorage; <recently-viewed-products> (sections/section-recently-viewed.liquid)
// renders those handles as cards via the Section Rendering API.

const STORAGE_KEY = 'ceres:recently-viewed';
const MAX_STORED = 20;
const CARD_SECTION = 'recently-viewed-product-card';

const readHandles = () => {
  try {
    const handles = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(handles) ? handles : [];
  } catch (e) {
    return [];
  }
};

const writeHandles = (handles) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  } catch (e) {
    // Storage blocked (private mode, quota) — the carousel just stays empty.
  }
};

// Most recent first, deduped. No-op off the product page.
export const trackRecentlyViewed = () => {
  const handle = document.querySelector('[data-recently-viewed-handle]')?.dataset.recentlyViewedHandle;
  if (!handle) return;

  const handles = readHandles().filter((h) => h !== handle);
  handles.unshift(handle);
  writeHandles(handles.slice(0, MAX_STORED));
};

const fetchCard = (rootUrl, handle) =>
  fetch(`${rootUrl}products/${encodeURIComponent(handle)}?section_id=${CARD_SECTION}`)
    // Products outside the customer's catalogue (or deleted) 404 — skip them.
    .then((response) => (response.ok ? response.text() : ''))
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      return html.querySelector('[data-recently-viewed-card]')?.innerHTML.trim() || '';
    })
    .catch(() => '');

export class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const { sectionId, limit, exclude, rootUrl } = this.dataset;
    const excluded = new Set((exclude || '').split(',').filter(Boolean));
    const max = parseInt(limit, 10) || 8;
    // Fetch a few extra so a handful of unavailable products doesn't leave the row short.
    const handles = readHandles().filter((h) => !excluded.has(h)).slice(0, max + 4);
    if (!handles.length) return;

    Promise.all(handles.map((handle) => fetchCard(rootUrl || '/', handle))).then((cards) => {
      const markup = cards
        .filter(Boolean)
        .slice(0, max)
        .map(
          (card, index) =>
            `<li id="Slide-${sectionId}-${index + 1}" class="grid__item slider__slide">${card}</li>`
        )
        .join('');
      if (!markup) return;

      this.querySelector(`#Slider-${sectionId}`).innerHTML = markup;
      this.hidden = false;

      // slider-component collected its (empty) slides in the constructor.
      this.querySelector('slider-component')?.resetPages?.();
      // Lets the custom scrollbar recompute its thumb now the row has content.
      window.dispatchEvent(new Event('resize'));
    });
  }
}
